import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { get_grid2d_key } from '@/utils/utils_grid2d';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__grid2d } from '../STATE__grid2d';

export const remote_grid2d_get_search = createAsyncThunkSafe<string, string>(
  ENUM__network_event_client_to_server.GRID2D_GET_SEARCH,
  async (search_id: string) => {
    await send_to_server(ENUM__network_event_client_to_server.GRID2D_GET_SEARCH, search_id);

    return search_id;
  },
);

export function init_remote_grid2d_get_search(builder: ActionReducerMapBuilder<STATE__grid2d>) {
  builder
    .addCase(remote_grid2d_get_search.pending, (state, action) => {
      let key = get_grid2d_key(ENUM__workspace_entity.ENTITY_SEARCH, action.meta.arg);

      state.grid2d_loading_in_progress.add(key);

      //need to force rerender
      state.grid2d_loading_in_progress = new Set(state.grid2d_loading_in_progress);
    })
    .addCase(remote_grid2d_get_search.rejected, (state, action) => {})
    .addCase(remote_grid2d_get_search.fulfilled, (state, action: PayloadAction<string>) => {
      get_grid2d_key(ENUM__workspace_entity.ENTITY_SEARCH, action.payload);

      state.grid2d_loading_in_progress.delete(action.payload);

      //need to force rerender
      state.grid2d_loading_in_progress = new Set(state.grid2d_loading_in_progress);
    });
}
